import type { FlotiqStore, FlotiqStoreApiItem } from "@jti/fe-common";

import type { StoreFilteringByAttributes, StoreLocatorCartItemProp } from "../types";

type MAGENT_PRODUCT_ATTRIBUTE_KEYS = "flavor_label" | "color_label";

const FLOTIQ_TO_MAGENTO_PRODUCT_ATTRIBUTE_KEYS_MAP: Record<string, MAGENT_PRODUCT_ATTRIBUTE_KEYS> = {
  flavour: "flavor_label",
  color: "color_label",
};

const hasProductType = (productType: string, flotiqStore: FlotiqStoreApiItem["item"]) => {
  if (!flotiqStore.product_types) {
    return false;
  }

  return flotiqStore.product_types.some((type) => type.key === productType && type.is_available === "true");
};

const checkStoreEligibility = (
  store: FlotiqStoreApiItem["item"],
  product: StoreLocatorCartItemProp,
  categoryAttributeFilter: StoreFilteringByAttributes
) => {
  const checkStoreLocatorCategory = (category: string) => {
    const productAttribute = store.product_attributes?.find(
      (productAttribute) => productAttribute.category === category
    );

    if (!productAttribute) {
      return hasProductType(category, store);
    }

    const magentoKey: MAGENT_PRODUCT_ATTRIBUTE_KEYS =
      FLOTIQ_TO_MAGENTO_PRODUCT_ATTRIBUTE_KEYS_MAP[productAttribute.key];

    if (!product[magentoKey]) {
      return false;
    }

    if ((categoryAttributeFilter && magentoKey === categoryAttributeFilter) || categoryAttributeFilter === "all") {
      const status = productAttribute.values.some(({ value }) => value === product[magentoKey]);
      return status;
    }
    return true;
  };

  const storeLocatorCategoryNames = (product.categories ?? [])
    .map(({ store_locator_name }) => store_locator_name)
    .filter((storeLocatorName): storeLocatorName is string => Boolean(storeLocatorName));

  return storeLocatorCategoryNames.every(checkStoreLocatorCategory);
};

export const getStoresFilteredByProductAttributes = (
  stores: FlotiqStore[],
  cartItems: StoreLocatorCartItemProp[],
  categoryAttributeFilter: StoreFilteringByAttributes
) => {
  return stores.filter((store) => {
    const hasStore = cartItems.every((cartItem) => checkStoreEligibility(store, cartItem, categoryAttributeFilter));
    return hasStore;
  });
};
